import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
const forWho = ['Hombres de 20 a 30 años que sienten que su cerebro está "nublado".', 'Estudiantes o profesionales que procastinan hasta el último momento.', 'Emprendedores que no pueden mantener el enfoque más de 5 minutos.', 'Personas que sienten que han perdido su "chispa" y curiosidad por el mundo real.'];
const notForWho = ['Quienes buscan "tips" rápidos sin estar dispuestos a desconectarse.', 'Personas que no creen que la tecnología afecte su rendimiento.', 'Quienes buscan una solución mágica sin 7 días de incomodidad voluntaria.'];
export function WhoIsFor() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-lighter px-4 py-16 md:py-24" data-id="element-144">
      <div className="max-w-5xl mx-auto" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="space-y-12" data-id="element-146">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-147">
            <div className="space-y-6" data-id="element-148">
              <h2 className="font-bebas text-3xl md:text-5xl text-teal leading-tight" data-id="element-149">
                PARA QUIÉN ES
              </h2>

              <div className="space-y-4" data-id="element-150">
                {forWho.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {
                opacity: 0,
                x: -20
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex items-start gap-3" data-id="element-151">
                    <CheckCircleIcon className="w-5 h-5 text-teal flex-shrink-0 mt-1" data-id="element-152" />
                    <p className="font-inter text-sm md:text-base text-text/80 leading-relaxed" data-id="element-153">
                      {item}
                    </p>
                  </motion.div>)}
              </div>
            </div>

            <div className="space-y-6" data-id="element-154">
              <h2 className="font-bebas text-3xl md:text-5xl text-amber leading-tight" data-id="element-155">
                PARA QUIÉN NO ES
              </h2>

              <div className="space-y-4" data-id="element-156">
                {notForWho.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {
                opacity: 0,
                x: -20
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex items-start gap-3" data-id="element-157">
                    <XCircleIcon className="w-5 h-5 text-amber flex-shrink-0 mt-1" data-id="element-158" />
                    <p className="font-inter text-sm md:text-base text-text/80 leading-relaxed" data-id="element-159">
                      {item}
                    </p>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}